module.exports = __webpack_public_path__ + "static/img/GYJB.8188f278.png";